<template>
  <div v-if="!isMobileAgent()" class="error--text fs-16px text-center">
    <div style="margin-top: 40vh">
      Chức năng chỉ hoạt động trên thiết bị di động
    </div>
  </div>
  <div v-else>
    <div>
      <v-row dense>
        <template v-if="!coords.latitude || !coords.longitude">
          <v-col cols="12" class="error--text fs-16px text-center">
            <div style="margin-top: 40vh">Chưa lấy được dữ liệu vị trí.</div>
          </v-col>
        </template>

        <template v-else>
          <v-col cols="12">
            <div class="">
              <v-radio-group
                v-model="type"
                hide-details
                class="c-input-small mt-0 mb-1"
              >
                <v-row dense>
                  <v-col cols="6">
                    <v-radio label="Đến" value="checkin"></v-radio>
                  </v-col>
                  <v-col cols="6">
                    <v-radio label="Về" value="checkout"></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>
          </v-col>

          <v-col cols="12">
            <v-btn
              block
              color="info"
              outlined
              @click="$refs.inputUploadFile.click()"
            >
              Chụp ảnh
            </v-btn>
            <input
              type="file"
              ref="inputUploadFile"
              accept="image/*"
              @change="onInputFileChange"
              capture="user"
              class="d-none"
            />
          </v-col>

          <v-col cols="12">
            <v-btn
              block
              color="success"
              :disabled="!fileUrl || !coords.latitude || !coords.longitude"
              @click="onCheck"
            >
              Chấm công
            </v-btn>
          </v-col>

          <v-col cols="12" v-if="fileUrl">
            <img :src="fileUrl" alt="" style="width: 100%; height: auto" />
          </v-col>
        </template>
      </v-row>

      <div class="mt-15">
        <input-qr-scan-model
          v-model="code"
          ref="codeRef"
          label="Quét mã khi chuyển cơ sở"
          @keyupEnter="scanInput"
        ></input-qr-scan-model>
      </div>
    </div>

    <v-fab-transition>
      <v-btn dark fixed bottom right fab color="info" @click="showDialogList">
        <v-icon>mdi-information-outline</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="dialogList" max-width="960px">
      <TimekeepingAccountList v-if="dialogList" @cancel="hideDialogList" />
    </v-dialog>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";
import moment from "moment";
import { compress } from "image-conversion";
import { ACTIVE_SHOP_CODE, EXIT_SHOP_CODE } from "@/libs/const";

export default {
  name: "Timekeeping",
  components: {
    TimekeepingAccountList: () =>
      import("@/components/account/TimekeepingAccountList.vue"),
  },
  data: () => ({
    type: "checkin",
    filePath: null,
    fileUpdateTime: null,
    coords: {},
    dialogList: false,
    code: null,
  }),
  computed: {
    fileUrl() {
      if (!this.filePath) {
        return null;
      }
      return `${process.env.VUE_APP_FILE_CDN_URL}/${this.filePath}`;
    },
  },
  created() {},
  mounted() {
    this.getLocation();
  },
  methods: {
    async scanInput() {
      if (!this.code) {
        return false;
      }

      const code = this.code.toUpperCase();

      if (code != EXIT_SHOP_CODE && !code.includes(ACTIVE_SHOP_CODE)) {
        this.$vToastify.error(this.$t("Mã QR không đúng"));
        document.getElementById("error_sound_player").play();
        return false;
      }

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      let id_branch = this.extractEmoveActiveShop(code);

      this.isLoading = true;

      try {
        await httpClient.post("/me/v1/set-working-branch", {
          id_branch,
        });
        this.code = null;
        this.isLoading = false;

        this.$vToastify.success("Cập nhật thành công");
        document.getElementById("success_sound_player").play();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.code = null;
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },
    showDialogList() {
      this.dialogList = true;
    },
    hideDialogList() {
      this.dialogList = false;
    },
    handlePermission() {
      const self = this;

      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        if (result.state === "granted") {
          self.getLocation();
        } else if (result.state === "prompt") {
          self.$t(result.state);
        } else if (result.state === "denied") {
          self.$vToastify.warning(self.$t("Location permission denied"));
        } else {
          self.$vToastify.error(self.$t(result.state));
        }
      });
    },

    async getLocation() {
      const self = this;
      if (!self.isMobileAgent()) {
        return false;
      }

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            const coords = { latitude, longitude };
            this.coords = { ...coords };
          },
          (err) => {
            switch (err.code) {
              case err.PERMISSION_DENIED:
                self.$vToastify.warning(this.$t("Location permission denied"));
                break;
              case err.POSITION_UNAVAILABLE:
                self.$vToastify.warning(this.$t("Location unavailable"));
                break;
              case err.TIMEOUT:
                self.$vToastify.warning(this.$t("Location timeout"));
                break;
              case err.UNKNOWN_ERROR:
                self.$vToastify.warning("UNKNOWN_ERROR");
                break;
            }
          },
          {
            enableHighAccuracy: true,
          }
        );
      } else {
        this.$vToastify.warning("Trình duyệt không hỗ trợ vị trí");
      }
    },

    async onInputFileChange(e) {
      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;
      let files = e.target.files || e.dataTransfer.files;
      if (files && files[0]) {
        this.filePath = await this.uploadFile(files[0]);
        this.fileUpdateTime = moment(files[0].lastModified).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.$refs.inputUploadFile.value = null;
      }
      this.isLoading = false;
    },
    async uploadFile(file) {
      const resBlob = await compress(file, {
        quality: 0.8,
        type: "image/jpeg",
        width: 480,
        height: 640,
      });
      const newFile = new File(
        [resBlob],
        `${moment().unix()}_${this.generateRandomString(9)}.jpg`,
        { type: "image/jpeg" }
      );
      let fd = new FormData();
      fd.append("file", newFile);

      const { data } = await httpClient.post(`/common/v1/upload-image`, fd);
      return data;
    },

    async onCheck() {
      try {
        await httpClient.post(`/me/v1/timekeeping`, {
          type: this.type,
          file_url: this.filePath,
          file_time: this.fileUpdateTime,
          lat: this.coords.latitude,
          lng: this.coords.longitude,
        });
        this.$vToastify.success("Chấm công thành công");
        this.filePath = null;
        this.fileUpdateTime = null;
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
      }
    },
  },
};
</script>

<style scoped></style>
